export const RECENT_FROM_MAILBOXES_KEY = "A7F3B2D1E4C5F608";
export const RECENT_FROM_MAILBOXES_LIMIT = 10;

export const getFromMailboxOptions = (
	currentUserEmail: string,
	recentMailboxes: string[],
): string[] => {
	const normalizedCurrentUserEmail = normalizeMailbox(currentUserEmail);

	return Array.from(
		new Set([
			normalizedCurrentUserEmail,
			...recentMailboxes
				.map(normalizeMailbox)
				.filter((mailbox) => mailbox.length > 0 && mailbox !== normalizedCurrentUserEmail),
		]),
	).filter((mailbox) => mailbox.length > 0);
};

export const rememberRecentFromMailbox = (
	recentMailboxes: string[],
	mailbox: string,
	currentUserEmail: string,
): string[] => {
	const normalizedCurrentUserEmail = normalizeMailbox(currentUserEmail);
	const normalizedMailbox = normalizeMailbox(mailbox);

	return Array.from(
		new Set([
			normalizedMailbox,
			...recentMailboxes.map(normalizeMailbox),
		]),
	)
		.filter((recentMailbox) => {
			return recentMailbox.length > 0 && recentMailbox !== normalizedCurrentUserEmail;
		})
		.slice(0, RECENT_FROM_MAILBOXES_LIMIT);
};

export const removeRecentFromMailbox = (
	recentMailboxes: string[],
	mailbox: string,
): string[] => {
	const normalizedMailbox = normalizeMailbox(mailbox);

	return recentMailboxes
		.map(normalizeMailbox)
		.filter((recentMailbox) => recentMailbox.length > 0 && recentMailbox !== normalizedMailbox);
};

function normalizeMailbox(mailbox: string): string {
	return mailbox.trim();
}
